var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamilyGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2274",
    "data-name": "Group 2274",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.881,
    height: 23.368,
    viewBox: "0 0 29.881 23.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    "data-name": "Path 3993",
    d: "M89.859,552.777a1.441,1.441,0,0,1-.042-.245c.011-1.178-.014-2.358.047-3.532a5.871,5.871,0,0,1,4.221-5.119.748.748,0,0,1,.491.072,6.6,6.6,0,0,0,6.515,0,.8.8,0,0,1,.527-.062,5.843,5.843,0,0,1,4.179,5.148c.059,1.162.035,2.328.045,3.491a1.449,1.449,0,0,1-.041.245Z",
    transform: "translate(-82.851 -529.409)",
    fill: "#ffbdbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    "data-name": "Path 3994",
    d: "M97.854,542.969a5.04,5.04,0,1,1,1.934-.388A5.052,5.052,0,0,1,97.854,542.969Z",
    transform: "translate(-82.859 -529.379)",
    fill: "#ffbdbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    d: "M95.036,531.672a6.953,6.953,0,0,0-3.9,7.814,5.042,5.042,0,1,1,3.9-7.814Z",
    transform: "translate(-82.84 -529.37)",
    fill: "#ffbdbf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    d: "M104.5,539.488a6.979,6.979,0,0,0-3.88-7.841,4.952,4.952,0,0,1,5.924-1.955,5.128,5.128,0,0,1,3.1,6.067A4.971,4.971,0,0,1,104.5,539.488Z",
    transform: "translate(-82.88 -529.37)",
    fill: "#ffbdbf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    d: "M112.736,549.285h-5.107a7.883,7.883,0,0,0-4.651-6.807c.26-.381.5-.752.768-1.1a.383.383,0,0,1,.142-.092.394.394,0,0,1,.167-.024,6.8,6.8,0,0,0,4.089-.875.607.607,0,0,1,.418-.011,5.806,5.806,0,0,1,4.153,4.9C112.821,546.586,112.736,547.915,112.736,549.285Z",
    transform: "translate(-82.887 -529.4)",
    fill: "#ffbdbf"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    d: "M88.042,549.259H82.858v-1.834a9.653,9.653,0,0,1,.3-3.212,5.9,5.9,0,0,1,3.9-3.823.737.737,0,0,1,.524.035,6.566,6.566,0,0,0,3.86.831.537.537,0,0,1,.616.307,8.986,8.986,0,0,0,.649.91,7.768,7.768,0,0,0-4.662,6.786Z",
    transform: "translate(-82.832 -529.4)",
    fill: "#ffbdbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyGroup1);
export default __webpack_public_path__ + "static/media/familyGroup1.49c7d1b21a41807fb4a53707f23cea99.svg";
export { ForwardRef as ReactComponent };